"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEditableImage = isEditableImage;
exports.imageIsOnlyChild = imageIsOnlyChild;
exports.hasEditableImage = hasEditableImage;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

function isEditableImage(editor, node) {
  return editor.dom.is(node, 'img:not([data-mce-object],[data-mce-placeholder])');
}

function imageIsOnlyChild(editor, node) {
  if (isEditableImage(editor, node)) return true;
  var childNodes = (0, _toConsumableArray2.default)(node.childNodes);

  if (childNodes.length === 1) {
    return imageIsOnlyChild(editor, childNodes[0]);
  }

  return false;
}

function hasEditableImage(editor, node) {
  if (isEditableImage(editor, node)) return true;
  return (0, _toConsumableArray2.default)(node.childNodes).reduce(function (acc, childNode) {
    return acc || hasEditableImage(editor, childNode);
  }, false);
}